import { Map } from 'immutable';
import { ReduxAction } from 'types/redux.types';
import { calendarActions } from './actions';

export interface CalendarState {
  addMeetingModalVisible: boolean;
  syncCalendarsModalVisible: boolean;

  slotInitialValues: {
    candidatesData: {
      source:
        | {
            page: 'selection-default' | 'selection-custom' | 'bulk' | 'calendar';
            label: string;
          }
        | undefined;
      editable: boolean;
      candidatesList: {
        name: string;
        id: number;
        phone: string;
        email: string;
        fromSite: number | null | undefined;
      }[];
    };
    job: {
      id: number;
      title: string;
    };
  };
}

export type SlotInitialValues = CalendarState['slotInitialValues'];

const initialState = Map<string, any>({
  slotInitialValues: {
    candidatesData: {
      source: undefined,
      editable: false,
      candidatesList: [],
    },
    job: {
      id: 0,
      title: '',
    },
  },
  addMeetingModalVisible: false,
  syncCalendarsModalVisible: false,
});

const calendarReducer = (state = initialState, action: ReduxAction) => {
  switch (action.type) {
    case calendarActions.SHOW_ADD_MEETING_MODAL:
      return state.set('addMeetingModalVisible', true);
    case calendarActions.HIDE_ADD_MEETING_MODAL:
      return state
        .set('addMeetingModalVisible', false)
        .set('slotInitialValues', initialState.get('slotInitialValues'));
    case calendarActions.SHOW_SYNC_MEETING_MODAL:
      return state.set('syncCalendarsModalVisible', true);
    case calendarActions.HIDE_SYNC_MEETING_MODAL:
      return state.set('syncCalendarsModalVisible', false);
    case calendarActions.SET_SLOT_INITIAL_VALUES:
      if (action.payload !== undefined) {
        return state.set('slotInitialValues', action.payload);
      }
      return state;

    default:
      return state;
  }
};

export default calendarReducer;
